const initialState = {
    data: [],
  };
  
const odczytyReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ODCZYTY':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default odczytyReducer;